import { render, staticRenderFns } from "./PdfPreview.vue?vue&type=template&id=5b2664c8"
import script from "./pdfPreview.js?vue&type=script&lang=js&external"
export * from "./pdfPreview.js?vue&type=script&lang=js&external"
import style0 from "./PdfPreview.vue?vue&type=style&index=0&id=5b2664c8&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-ontraining-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b2664c8')) {
      api.createRecord('5b2664c8', component.options)
    } else {
      api.reload('5b2664c8', component.options)
    }
    module.hot.accept("./PdfPreview.vue?vue&type=template&id=5b2664c8", function () {
      api.rerender('5b2664c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/video-training/components/pdf-preview/PdfPreview.vue"
export default component.exports